import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(
    () => localStorage.getItem('theme') || 'dark'
  );

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  // Color de marca de la sesión. El rol "Operador de Agua" guarda brand=agua
  // al iniciar sesión y toda la interfaz pasa de naranja a azul mediante las
  // variables --brand* de main.css. Cualquier otro usuario no lleva atributo
  // y se queda con el naranja Corvana por defecto.
  useEffect(() => {
    const brand = localStorage.getItem('brand');
    if (brand) document.documentElement.setAttribute('data-brand', brand);
    else       document.documentElement.removeAttribute('data-brand');
  }, []);

  const toggleTheme = () =>
    setTheme(t => (t === 'dark' ? 'light' : 'dark'));

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
